<template>
  <div class="payments">
    <div class="table table--inner">
      <div class="table__header table__header--inner">
        <div class="table__label table__label--medium">Prämie</div>
        <div class="table__label table__label--medium">Status</div>
        <div class="table__label table__label--medium">Dokument</div>
        <div class="table__label table__label--medium">Zahlungsstatus</div>
        <div class="table__label table__label--large">Betrag</div>
      </div>

      <div class="table__body">
        <Loading v-if="detailsLoading" />
        <template v-else>
          <Invoice v-for="(invoice, index) in invoices" :key="invoice.id" :invoice="invoice"
            :isLast="index === invoices.length - 1" :priceSum="priceSum" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Invoice from "@/components/AccountDetails/Invoice";
import Loading from "@/partials/Loading";
export default {
  name: "InovicesTable",

  components: {
    Invoice,
    Loading,
  },

  props: {
    invoices: {
      required: true,
      type: Array,
    },

    detailsLoading: {
      required: true,
      type: Boolean,
    },
  },

  computed: {
    priceSum() {
      return this.invoices.reduce(
        (acc, invoice) => (acc += Number(invoice.price)),
        0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  &__label {
    padding-left: 40px;
    padding-right: 0;

    &:last-of-type {
      padding-right: 70px;
      text-align: center !important;
    }
  }
}

.loading {
  height: 76vh;
}
</style>
